import React from 'react';
import { CtaButton } from '../CtaButton';
import { CORE_PROMISE, PRICE } from '../../data/salesContent';
export function FinalCtaSection() {
  return <section className="border-t border-ink-line bg-ink px-5 pb-12 pt-20 md:pt-28" data-id="element-62" data-mp="23na1o4xdzl50">
      <div className="mx-auto max-w-3xl text-center" data-id="element-63" data-mp="2ijraopi3snoe">
        <p className="text-sm font-bold uppercase tracking-[0.25em] text-gold md:text-base" data-id="element-64" data-mp="2dittaf4x3xny">Primeros Auxilios para Instructores™</p>
        <h2 className="mt-6 font-display text-4xl font-black uppercase leading-tight text-cream md:text-6xl" data-id="element-65" data-mp="2rhtfzh8ve2hh">{CORE_PROMISE}</h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-neutral-400 md:text-xl" data-id="element-66" data-mp="2mhyopcl6navw">
          Tené en un solo lugar un método para enseñar, contenidos para entrenar y herramientas para practicar, evaluar y organizar
          tus capacitaciones.
        </p>
        <p className="mt-10 font-display text-base font-extrabold uppercase tracking-widest text-cream md:text-lg" data-id="element-67" data-mp="3aa5hy2vm31r3">
          3 volúmenes + 5 bonos prácticos
        </p>
        <p className="mt-2 font-display text-5xl font-black text-gold md:text-6xl" data-id="element-68" data-mp="221cmwb57tvzi">{PRICE}</p>
        <p className="mt-3 text-base text-neutral-300 md:text-lg" data-id="element-69" data-mp="261mufs8nough">Pago único · Acceso digital inmediato</p>
        <div className="mt-10" data-id="element-70" data-mp="2b0zn4tm7kvqz">
          <CtaButton data-id="element-71" data-mp="2azy15u3nmouh">Quiero el sistema completo</CtaButton>
        </div>
      </div>
      <footer className="mx-auto mt-24 max-w-4xl border-t border-ink-line pt-8 text-center text-sm text-neutral-500" data-id="element-72" data-mp="2g157rpu29hzk">
        © 2026 Primeros Auxilios para Instructores™ · Todos los derechos reservados
      </footer>
    </section>;
}